import { render, staticRenderFns } from "./CustomUploader.vue?vue&type=template&id=78f05dd0&scoped=true&"
import script from "./CustomUploader.vue?vue&type=script&lang=ts&"
export * from "./CustomUploader.vue?vue&type=script&lang=ts&"
import style0 from "./CustomUploader.vue?vue&type=style&index=0&id=78f05dd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f05dd0",
  null
  
)

export default component.exports